/* =====================================================================
   FRACAZ · secciones FZ de la copia (Our backpack, pilares y cierre)
   Apariciones al hacer scroll, titulares que se ajustan y visor de
   detalles con zoom. Sin dependencias. Respeta «reducir movimiento».
   ===================================================================== */
(function () {
  'use strict';
  if (window.__fzSections) return;
  window.__fzSections = true;

  var doc = document.documentElement;
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopMQ = window.matchMedia('(min-width: 990px)');
  var motionOK = function () { return !reduceMQ.matches; };
  var vh = window.innerHeight;
  var vw = window.innerWidth;

  function $all(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function viewH() { return window.innerHeight || doc.clientHeight || vh || 800; }

  // Conexión lenta (o ahorro de datos): no se piden las fotos en alta, se queda la versión ligera
  function slowNet() {
    var c = navigator.connection;
    if (c) {
      if (c.saveData) return true;
      if (/(^|-)2g|3g/.test(c.effectiveType || '')) return true;
      if (c.downlink && c.downlink < 1.5) return true;
    }
    try {
      var bytes = 0, ms = 0;
      performance.getEntriesByType('resource').forEach(function (e) {
        if (e.initiatorType === 'img' && e.encodedBodySize > 30000 && e.responseEnd > e.responseStart) {
          bytes += e.encodedBodySize;
          ms += e.responseEnd - e.responseStart;
        }
      });
      if (ms > 0 && bytes / ms < 150) return true; // menos de ~150 KB/s
    } catch (e) {}
    return false;
  }

  function scrollToEl(el, align, offset) {
    if (!el) return;
    var r = el.getBoundingClientRect();
    var y = window.scrollY + r.top - (offset || 0);
    if (align === 'center') y = window.scrollY + r.top + r.height / 2 - vh / 2;
    window.scrollTo({ top: Math.max(0, y), behavior: motionOK() ? 'smooth' : 'auto' });
  }

  /* ---------- Texto dividido en palabras ---------- */
  function splitWords(el) {
    if (el.__fzSplit) return;
    el.__fzSplit = true;
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var parts = child.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'fz-w';
            var inner = document.createElement('span');
            inner.textContent = part;
            inner.style.setProperty('--i', i++);
            w.appendChild(inner);
            frag.appendChild(w);
          });
          child.parentNode.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR' && !child.classList.contains('fz-w')) {
          walk(child);
        }
      });
    })(el);
    el.classList.add('is-split');
  }

  /* ---------- Apariciones ---------- */
  var revealMap = new WeakMap();
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      (revealMap.get(e.target) || [e.target]).forEach(function (t) { t.classList.add('is-in'); });
      revealMap.delete(e.target);
      revealIO.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < vh;
  }

  function watchReveal(el) {
    if (el.classList.contains('is-in')) return;
    if (!motionOK()) { el.classList.add('is-in'); return; }
    var target = el;
    if (el.getAttribute('data-fz-reveal') === 'mask' && el.parentElement) target = el.parentElement;
    if (inView(target)) { el.classList.add('is-in'); return; }
    var list = revealMap.get(target);
    if (list) { list.push(el); return; }
    revealMap.set(target, [el]);
    revealIO.observe(target);
  }

  function initReveals(root) {
    $all(root, '[data-fz-split]').forEach(function (el) { splitWords(el); watchReveal(el); });
    $all(root, '[data-fz-reveal]').forEach(watchReveal);
  }

  /* ---------- Titulares grandes: si una palabra no cabe, se reduce el cuerpo ---------- */
  function fitTitles(root) {
    $all(root, '.fz .fz-display').forEach(function (h) {
      h.style.removeProperty('font-size');
      var avail = h.clientWidth;
      var text = (h.textContent || '').trim();
      if (!avail || !text) return;
      var probe = document.createElement('span');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;white-space:nowrap;pointer-events:none;';
      h.appendChild(probe);
      var widest = 0;
      text.split(/\s+/).forEach(function (w) {
        probe.textContent = w;
        var ww = probe.getBoundingClientRect().width;
        if (ww > widest) widest = ww;
      });
      h.removeChild(probe);
      if (widest > avail + 1) {
        var fs = parseFloat(getComputedStyle(h).fontSize) || 0;
        if (fs) h.style.fontSize = Math.floor(fs * (avail / widest) * 0.97) + 'px';
      }
    });
  }

  /* ---------- Visor por pasos con zoom (Our backpack) ----------
     Con movimiento: la foto y los textos se quedan fijos («escenario») y cada paso tiene su tramo de
     scroll. Al cruzar al tramo siguiente cambia el paso activo: el texto hace su transición en CSS
     (sale hacia la izquierda y entra el siguiente; al subir, al revés) y la foto viaja a su nuevo
     encuadre con FLIP: se coloca ya en su tamaño final (nítida) y una transformación temporal la
     lleva desde donde estaba. Así el movimiento va fluido aunque el scroll vaya a saltos.
     Sin movimiento: lista vertical, sin animaciones. */
  var stepGroups = new Set();
  var ZOOM_MS = 1250;
  var ZOOM_EASE = 'cubic-bezier(0.19, 1, 0.22, 1)';

  function initSteps(root) {
    $all(root, '[data-fz-steps]').forEach(function (group) {
      if (group.__fzSteps) return;
      var viewer = group.querySelector('[data-fz-viewer]');
      var steps = $all(group, '[data-fz-step]');
      if (!steps.length) return;
      var layers = viewer ? $all(viewer, '[data-fz-layer]') : [];
      var counter = group.querySelector('[data-fz-step-count]');
      var label = group.querySelector('[data-fz-step-label]');
      var zoomEl = group.querySelector('[data-fz-zoom]');
      var stage = group.querySelector('[data-fz-stage]');
      var list = steps[0].parentElement;
      var fill = group.querySelector('[data-fz-progress]');
      var idxBtns = $all(group, '[data-fz-index] [data-fz-goto]');
      var section = group.closest('.fz-func') || group;
      var n = steps.length;
      var active = -1;
      var io = null;
      var horiz = false;
      var ticking = false;

      // El visor se queda fijo bajo la cabecera de la tienda: cuenta su desplazamiento
      function viewerTop() { return viewer ? parseFloat(getComputedStyle(viewer).top) || 0 : 0; }

      // Marco más alto que ancho (móvil): el zoom se compensa para enseñar la misma zona que en
      // un marco casi cuadrado, que es para el que están pensados los puntos de zoom.
      var frame = viewer ? viewer.querySelector('.fz-func__frame') : null;
      function setFrameK() {
        if (!frame || !frame.clientHeight) return;
        var k = Math.min(1, frame.clientWidth / frame.clientHeight / 0.92);
        frame.style.setProperty('--fz-k', k.toFixed(4));
      }
      if (frame && window.ResizeObserver) new ResizeObserver(setFrameK).observe(frame);

      // FLIP: la capa ya está en su sitio nuevo; una transformación la devuelve a donde se veía
      // y se suelta con transición hasta cero.
      function flipFrom(layer, first) {
        var last = layer.getBoundingClientRect();
        if (!first || !last.width || !first.width) return;
        var sc = first.width / last.width;
        var dx = first.left - last.left;
        var dy = first.top - last.top;
        if (Math.abs(sc - 1) < 0.001 && Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;
        layer.style.transform = 'translate(' + dx.toFixed(2) + 'px, ' + dy.toFixed(2) + 'px) scale(' + sc.toFixed(5) + ')';
        void layer.offsetWidth;
        layer.style.transition = 'transform ' + ZOOM_MS + 'ms ' + ZOOM_EASE + ', opacity 0.9s ease';
        layer.style.transform = 'none';
      }

      function activate(k) {
        if (k === active || k < 0 || k >= n) return;
        var first = active < 0;
        active = k;
        var s = steps[k];
        steps.forEach(function (st, j) {
          st.classList.toggle('is-active', j === k);
          st.classList.toggle('is-past', j < k);
        });
        idxBtns.forEach(function (b) {
          var on = parseInt(b.getAttribute('data-fz-goto'), 10) === k;
          b.classList.toggle('is-active', on);
          if (on) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
        });

        var key = s.getAttribute('data-layer') || 'main';
        var target = null;
        layers.forEach(function (l) { if (l.getAttribute('data-fz-layer') === key) target = l; });
        var animate = !!(target && !first && motionOK() && target.classList.contains('is-active') && target.offsetWidth);
        var from = null;
        if (animate) {
          from = target.getBoundingClientRect();
          target.style.transition = 'none';
          target.style.transform = 'none';
        }
        layers.forEach(function (l) {
          var on = l === target;
          l.classList.toggle('is-active', on);
          if (on) {
            l.style.setProperty('--z', s.getAttribute('data-zoom') || 1);
            l.style.setProperty('--fx', s.getAttribute('data-fx') || 0.5);
            l.style.setProperty('--fy', s.getAttribute('data-fy') || 0.5);
          }
        });
        if (viewer) viewer.setAttribute('data-step', s.getAttribute('data-kind') || 'detail');
        if (animate) flipFrom(target, from);

        if (counter) counter.textContent = pad(k + (steps[0].getAttribute('data-kind') === 'overview' ? 0 : 1));
        if (label) label.textContent = s.getAttribute('data-label') || '';
        if (zoomEl) zoomEl.textContent = (parseFloat(s.getAttribute('data-zoom')) || 1).toFixed(1);
        if (fill && !horiz) fill.style.transform = 'scaleX(' + (n > 1 ? k / (n - 1) : 1).toFixed(4) + ')';
      }

      /* --- Modo por tramos (escenario fijo) --- */
      function stageTop() { return stage ? parseFloat(getComputedStyle(stage).top) || 0 : 0; }
      function hProgress() {
        var r = group.getBoundingClientRect();
        var dist = r.height - stage.offsetHeight;
        return dist > 0 ? clamp((stageTop() - r.top) / dist, 0, 1) : 0;
      }
      function hUpdate() {
        ticking = false;
        if (!horiz) return;
        var p = hProgress();
        if (fill) fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        activate(clamp(Math.floor(p * n), 0, n - 1));
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(hUpdate); }
      }
      function setMode() {
        var want = !!(stage && list && n > 1 && motionOK());
        if (want === horiz) return;
        horiz = want;
        section.classList.toggle('fz-func--h', horiz);
        if (horiz) {
          if (io) { io.disconnect(); io = null; }
          window.addEventListener('scroll', onScroll, { passive: true });
          hUpdate();
        } else {
          window.removeEventListener('scroll', onScroll);
          steps.forEach(function (st) { st.classList.remove('is-past'); });
          layers.forEach(function (l) { l.style.transition = ''; l.style.transform = ''; });
          if (fill) fill.style.transform = 'scaleX(' + (n > 1 ? Math.max(active, 0) / (n - 1) : 1).toFixed(4) + ')';
        }
      }
      // Lleva el scroll al centro del tramo del paso k
      function goTo(k) {
        if (!horiz) return false;
        var r = group.getBoundingClientRect();
        var dist = group.offsetHeight - stage.offsetHeight;
        var p = (k + 0.5) / n;
        var y = window.scrollY + r.top - stageTop() + p * dist;
        window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: motionOK() ? 'smooth' : 'auto' });
        return true;
      }

      /* --- Modo vertical (lista): el paso activo es el que cruza una línea de la pantalla --- */
      function bind() {
        setMode();
        setFrameK();
        if (horiz) { hUpdate(); return; }
        if (io) io.disconnect();
        var h = viewH();
        var margin = '-48% 0px -48% 0px';
        if (!desktopMQ.matches && viewer && getComputedStyle(viewer).display !== 'none') {
          var vb = viewerTop() + viewer.offsetHeight;
          var line = Math.min(h - 40, vb + (h - vb) * 0.35);
          var top = Math.round((line / h) * 100);
          if (isFinite(top)) margin = '-' + clamp(top, 1, 98) + '% 0px -' + clamp(99 - top, 1, 98) + '% 0px';
        }
        try {
          io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) activate(steps.indexOf(e.target)); });
          }, { rootMargin: margin, threshold: 0 });
          steps.forEach(function (s) { io.observe(s); });
        } catch (err) { io = null; }
      }

      $all(group, '[data-fz-goto]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var k = parseInt(btn.getAttribute('data-fz-goto'), 10);
          var t = steps[k];
          if (!t) return;
          if (goTo(k)) return;
          if (desktopMQ.matches || !viewer) scrollToEl(t, 'center');
          else scrollToEl(t, 'top', viewerTop() + viewer.offsetHeight - 8);
        });
      });

      // La foto a resolución original (para que el zoom sea nítido) no se pide al cargar la página,
      // para no competir con la portada: se pide la primera vez que alguien baja (o toca el visor)
      // con la sección cerca. Se descarga aparte y se cambia cuando ya está lista, sin parpadeo.
      // Con conexión lenta no se pide: se queda la versión ligera (que ya se ve bien).
      var imgs = viewer ? $all(viewer, 'img[loading="lazy"]') : [];
      var hires = viewer ? $all(viewer, 'img[data-fz-hires]') : [];
      if (imgs.length || hires.length) {
        var near = false;
        var scrolled = false;
        var upgraded = false;
        var upgrade = function () {
          if (upgraded) return;
          upgraded = true;
          window.removeEventListener('scroll', onFirstScroll);
          if (pre) pre.disconnect();
          imgs.forEach(function (im) { im.loading = 'eager'; });
          if (slowNet()) return;
          hires.forEach(function (im) {
            var url = im.getAttribute('data-fz-hires');
            if (!url) return;
            var big = new Image();
            big.onload = function () {
              var swap = function () {
                im.removeAttribute('srcset');
                im.removeAttribute('sizes');
                im.src = url;
              };
              if (big.decode) big.decode().then(swap, swap);
              else swap();
            };
            big.src = url;
          });
        };
        var onFirstScroll = function () {
          scrolled = true;
          if (near) upgrade();
        };
        window.addEventListener('scroll', onFirstScroll, { passive: true });
        var pre = null;
        try {
          pre = new IntersectionObserver(function (entries) {
            near = entries.some(function (e) { return e.isIntersecting; });
            if (near && scrolled) upgrade();
          }, { rootMargin: '150% 0px 150% 0px' });
          pre.observe(group);
        } catch (err) {
          near = true;
        }
        $all(group, '[data-fz-goto]').forEach(function (b) {
          b.addEventListener('pointerdown', upgrade, { once: true });
        });
      }

      group.__fzSteps = {
        activate: function (k) { if (!goTo(k)) activate(k); },
        steps: steps
      };
      stepGroups.add({ root: group, rebind: bind });
      if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', bind);
      activate(0);
      bind();
    });
  }

  function rebindAll() {
    stepGroups.forEach(function (g) { if (g.root.isConnected) g.rebind(); else stepGroups.delete(g); });
  }

  /* ---------- Cabecera fija del tema: el visor arranca justo debajo de ella ---------- */
  function trackHeader() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    var last = -1;
    function set() {
      var pos = getComputedStyle(h).position;
      var hh = Math.round((pos === 'sticky' || pos === 'fixed') ? h.getBoundingClientRect().height : 0);
      if (hh === last) return;
      last = hh;
      doc.style.setProperty('--fz-header-h', hh + 'px');
      rebindAll();
    }
    set();
    window.addEventListener('load', set);
    if (window.ResizeObserver) new ResizeObserver(set).observe(h);
  }

  /* ---------- Arranque y editor de temas ---------- */
  function init(root) {
    initReveals(root);
    initSteps(root);
  }

  function boot() {
    trackHeader();
    fitTitles(document);
    init(document);
    doc.classList.add('fz-ready');
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fitTitles(document); rebindAll(); });
    }
    window.addEventListener('load', function () { fitTitles(document); rebindAll(); });
  }

  window.addEventListener('resize', function () {
    var widthChanged = window.innerWidth !== vw;
    vw = window.innerWidth;
    vh = window.innerHeight;
    if (widthChanged) { fitTitles(document); rebindAll(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    fitTitles(e.target);
    init(e.target);
    rebindAll();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest ? e.target.closest('[data-fz-step]') : null;
    if (step) {
      var group = step.closest('[data-fz-steps]');
      if (group && group.__fzSteps) group.__fzSteps.activate(group.__fzSteps.steps.indexOf(step));
    }
    $all(e.target, '[data-fz-reveal], [data-fz-split]').forEach(function (el) { el.classList.add('is-in'); });
    if (e.target.matches && e.target.matches('[data-fz-reveal]')) e.target.classList.add('is-in');
  });
})();